import * as React from 'react';
import {connect} from 'react-redux';

import _ from 'underscore';

import {ConfigModal} from '../../dash-grid/dash-config/config-modal';
// @ts-expect-error
import * as actions from '../../dashboard-actions';
// @ts-expect-error
import * as selectors from '../../dashboard-selectors';

import styles from './dash-grid-container.module.css';

type StateProps = {
    scrollTop: number;
};

// @ts-expect-error
const mapStateToProps = function (state): StateProps {
    return {
        scrollTop: selectors.getLeftScrollTop(state),
    };
};

type DispatchProps = {
    onConfigModalClose: () => void;
    onScroll: (arg1: number) => void;
};

// @ts-expect-error
const mapDispatchToProps = function (dispatch): DispatchProps {
    return {
        onConfigModalClose: () => {
            dispatch(actions.toggleConfigureDash());
            dispatch(actions.clearDashboardPreview());
        },
        onScroll: (scrollTop) => {
            dispatch(actions.saveLeftScrollPosition(scrollTop));
        },
    };
};

type OwnProps = {
    children: any;
};

type Props = OwnProps & StateProps & DispatchProps;

export class DashGridContainerComponent extends React.Component<Props> {
    // @ts-expect-error
    delayedScrollCallback: (e: React.SyntheticEvent) => void;
    leftPane: HTMLElement | null | undefined;

    // Do not re-render if scrollTop changes, only if children change
    shouldComponentUpdate(nextProps: Props) {
        return nextProps.children !== this.props.children;
    }

    UNSAFE_componentWillMount() {
        this.delayedScrollCallback = _.debounce((e) => {
            // @ts-expect-error
            this.props.onScroll(e.nativeEvent.target.scrollTop);
        }, 200);
    }

    componentDidMount() {
        if (this.leftPane) {
            this.leftPane.scrollTop = this.props.scrollTop;
        }
    }

    render() {
        return (
            <div
                onScroll={this.handleScroll}
                ref={(c) => {
                    this.leftPane = c;
                }}
                className={styles['dashboard-container']}
            >
                {this.props.children}
                <ConfigModal onClose={this.props.onConfigModalClose} />
            </div>
        );
    }

    handleScroll = (e: React.SyntheticEvent) => {
        e.persist(); // See http://stackoverflow.com/a/24679479 as to why this call is made here
        this.delayedScrollCallback(e);
    };
}

// @ts-expect-error
const connector = connect<Props, OwnProps, _, _, _, _>(mapStateToProps, mapDispatchToProps);

export const DashGridContainer = connector(DashGridContainerComponent);
